import React, { Component } from 'react';

class Imprint extends Component {
    render() {
        return (
          <section className="page imprint">
            <h1 className="title">Impressum</h1>
            <h2>Anschrift</h2>
            <p>
              ERB-Kauf GmbH<br />
              Bennostraße 2 <br />
              13053 Berlin <br />
              <br />
              Telefon: +49 30 34 64 98 700 <br />
              Telefax: +49 30 34 64 98 750 <br />
              <br /> 
              Geschäftszeiten: Montag bis Donnerstag: 8.30 Uhr bis 17.30 Uhr und Freitag: 8.00 Uhr bis 14.00 Uhr.
              <br />
              <a href="mailto:mail@erb-kauf.de" target="_blank" rel="noopener noreferrer">mail@erb-kauf.de</a> <br />
            </p>
            <h2>Geschäftsleitung</h2>
            <p>
              Dr. Dirk Zeiseler
            </p>
            <h2>Handelregister</h2>
            <p>
              Amtsgericht Charlottenburg<br />
              HRB 198255 B
            </p>
          </section>
        );
    }
}

export default Imprint;


// WEBPACK FOOTER //
// ./src/pages/Imprint.js